const invertedMessages = {
  'You can now configure user modification workflow to include ID proofing workflow stage.':
    'external.idp.enabled.successText',
  'Are you sure you want to enable ID proofing?':
    'external.idp.enable.confirmation',
  'Third party cost may be incurred.': 'external.idp.enable.subtext',
  Apply: 'external.idp.apply',
  Cancel: 'external.idp.cancel',
  'Are you sure you want to disable ID proofing?': 'external.idp.disable.title',
  Disable: 'external.idp.disable',
  'Data Fetch Error': 'external.idp.dataError',
  'ID Proofing configuration Action failed, please try again later.':
    'external.idp.dataError.message',
  'ID Proofing': 'external.idp.idProofing',
  'Settings have been updated successfully.': 'external.idp.save.successText',
};

export default invertedMessages;
